export const fallbackExchangeData = [
  {
    id: "binance",
    name: "Binance",
    year_established: 2017,
    country: "Cayman Islands",
    description: "Binance is a global cryptocurrency exchange",
    url: "https://www.binance.com",
    image: "https://assets.coingecko.com/markets/images/52/small/binance.jpg",
    trust_score: 10,
    trust_score_rank: 1,
    trade_volume_24h_btc: 489321.34,
    trade_volume_24h_btc_normalized: 489321.34
  },
  {
    id: "coinbase",
    name: "Coinbase Exchange",
    year_established: 2012,
    country: "United States",
    description: "Coinbase is a US-based cryptocurrency exchange",
    url: "https://www.coinbase.com",
    image: "https://assets.coingecko.com/markets/images/23/small/Coinbase_Coin.png",
    trust_score: 10,
    trust_score_rank: 2,
    trade_volume_24h_btc: 156432.21,
    trade_volume_24h_btc_normalized: 156432.21
  },
  {
    id: "kraken",
    name: "Kraken",
    year_established: 2011,
    country: "United States",
    description: "Kraken is a US-based cryptocurrency exchange",
    url: "https://www.kraken.com",
    image: "https://assets.coingecko.com/markets/images/29/small/kraken.jpg",
    trust_score: 10,
    trust_score_rank: 3,
    trade_volume_24h_btc: 98765.43,
    trade_volume_24h_btc_normalized: 98765.43
  }
];